import { DestroyRef, effect, ElementRef, inject, signal } from '@angular/core';
import { Vector2Screen } from '@typings/vectors';

export function asyncComputed<T>(computation: () => Promise<T>) {
  const s = signal<T | undefined>(undefined);
  effect(async () => {
    s.set(await computation());
  });
  return s;
}

export function useCleanup(callback: () => void): void {
  const destroyRef = inject(DestroyRef);
  destroyRef.onDestroy(callback);
}

export function useElementSize() {
  const elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  const destroyRef = inject(DestroyRef);

  const el = elementRef.nativeElement;
  const size = signal([el.clientWidth, el.clientHeight] as Vector2Screen);

  const observer = new ResizeObserver(() => {
    size.set([el.clientWidth, el.clientHeight] as Vector2Screen);
  });

  observer.observe(el);

  destroyRef.onDestroy(() => observer.disconnect());

  return size;
}
